import { render, staticRenderFns } from "./ShapePanel.vue?vue&type=template&id=0887531a&scoped=true"
import script from "./ShapePanel.vue?vue&type=script&lang=js"
export * from "./ShapePanel.vue?vue&type=script&lang=js"
import style0 from "./ShapePanel.vue?vue&type=style&index=0&id=0887531a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887531a",
  null
  
)

export default component.exports